module.exports = __webpack_public_path__ + "static-appopensalud/img/opensalud360-blue.2a75ca9.svg";


//////////////////
// WEBPACK FOOTER
// ./static-appopensalud/img/logos/opensalud360-blue.svg
// module id = 1070
// module chunks = 120